export const pocConstants = {
  LOAD: 'pocConstants/LOAD',
  LOAD_SUCCESS: 'pocConstants/LOAD_SUCCESS',
  LOAD_FAIL: 'pocConstants/LOAD_FAIL',
  POC_FLUSH: 'pocConstants/POC_FLUSH',
  SEND_ID: 'pocConstants/SEND_ID',
};
